import { useState } from "react";
import { CyberpassButton, CyberpassInput } from "../Input";
import Modal from "../Modal";
import * as customerApi from "../api/customer";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { selectCurrent } from "../store/customer";
import { useTranslation } from "../i18n";
import { selectAccessToken } from "../store/auth";

/**
 * @returns {React.Component}
 */
function ImportPaperWallet() {
  const { t } = useTranslation();
  /**
   * @type {RegisteredCustomer}
   */
  const customer = useSelector(selectCurrent);
  /**
   * @type {AccessToken}
   */
  const accessToken = useSelector(selectAccessToken);
  const [showModal, setShowModal] = useState(false);

  const [paperWalletNumber, setPaperWalletNumber] = useState("");
  const [paperWalletBalance, setPaperWalletBalance] = useState(0);

  const isImportPaperWalletVisible = () => {
    const today = new Date();
    const givenDate = new Date(customer.createdAt);
    today.setDate(today.getDate() - 30);
    return givenDate >= today;
  };

  /**
   * @type {React.ChangeEventHandler<HTMLInputElement>}
   */
  const updatePaperWalletBalance = (evt) => {
    // Remove spaces and leading zeros first
    let cleanedValue = evt.target.value.replace(/\s/g, "");
    while (cleanedValue.startsWith("0")) {
      cleanedValue = cleanedValue.slice(1);
    }

    // Check length after cleanup
    if (cleanedValue.length > 3) {
      return;
    }

    evt.target.value = cleanedValue;
    const value = Number(cleanedValue);
    setPaperWalletBalance(Math.max(value, 0));
  };

  const handleWheelPaperWallet = (evt) => {
    evt.preventDefault();
  };

  const handleWheelPaperWalletNumber = (evt) => {
    evt.preventDefault();
  };

  const updatePaperWalletNumber = (evt) => {
    const value = evt.target.value;
    if (value < 0) {
      evt.target.value = "0";
      setPaperWalletNumber("0");
    } else {
      setPaperWalletNumber(value);
    }
  };

  const onConfirm = () => {
    const resp = customerApi
      .importPaperWallet(accessToken, {
        customer: { id: customer.id },
        paperWallet: {
          id: paperWalletNumber,
          minutesBalance: paperWalletBalance,
        },
      })
      .then(() => {
        setPaperWalletNumber("");
        setPaperWalletBalance(0);
      });
    toast.promise(
      resp,
      {
        success: t("toast.paperWalletImported"),
        error: t("toast.paperWalletVerifyFailed"),
      },
      {
        error: {
          duration: 5000,
        },
      },
    );
  };

  return (
    customer != null &&
    isImportPaperWalletVisible() && (
      <>
        <CyberpassButton style="secondary" onClick={() => setShowModal(true)}>
          {t("importPaperWallet.button")}
        </CyberpassButton>
        <Modal
          title={t("importPaperWallet.title")}
          showModal={showModal}
          setShowModal={setShowModal}
          hideConfirmButton={true}
          content={
            <form id="import-wallet-form" className="flex flex-col space-y-2">
              <CyberpassInput
                required={true}
                id="paperWalletNumber"
                label={t("importPaperWallet.walletNumber")}
                type="number"
                onChange={updatePaperWalletNumber}
                value={paperWalletNumber}
                onWheel={handleWheelPaperWalletNumber}
              />
              <div className="flex flex-col space-y-2">
                <label
                  htmlFor="paperWalletBalance"
                  className="text-sm font-medium text-gray-300"
                >
                  {t("importPaperWallet.balance")}
                </label>
                <div className="h-32 bg-c-gray-500 rounded-lg flex flex-col items-center justify-center">
                  <div className="flex flex-row items-center justify-between w-full px-4">
                    <button
                      type="button"
                      className="px-2 py-0.5 bg-c-gray-600 rounded text-gray-300"
                      onClick={() => {
                        setPaperWalletBalance(
                          Math.max(paperWalletBalance - 20, 0),
                        );
                      }}
                    >
                      - 20
                    </button>
                    <input
                      id="paperWalletBalance"
                      type="number"
                      min="0"
                      required
                      value={paperWalletBalance}
                      onChange={updatePaperWalletBalance}
                      onWheel={handleWheelPaperWallet}
                      className="w-48 text-4xl text-center text-white ring-0 shadow-none bg-c-gray-500 focus:ring-0 focus:border-none focus:shadow-none focus:outline-none"
                    />
                    <button
                      type="button"
                      className="px-2 py-0.5 bg-c-gray-600 rounded text-gray-300"
                      onClick={() => {
                        setPaperWalletBalance(
                          Math.min(paperWalletBalance + 20, 999),
                        );
                      }}
                    >
                      + 20
                    </button>
                  </div>
                </div>
              </div>
              <span className="h-6" />
              <CyberpassButton
                type="submit"
                width="fit"
                className="self-center"
                onClick={(/** @type {Event} */ e) => {
                  e.preventDefault();
                  const form = document.getElementById("import-wallet-form");
                  if (!form.checkValidity()) {
                    form.reportValidity();
                    return;
                  }
                  setShowModal(false);
                  onConfirm();
                }}
              >
                {t("common.import")}
              </CyberpassButton>
            </form>
          }
        />
      </>
    )
  );
}

export default ImportPaperWallet;
